import { Typography, Skeleton } from '@ui/components';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

interface SubscriptionBillingProps {
  billingPeriod?: string;
  isLoading?: boolean;
}

export const SubscriptionBilling: FC<SubscriptionBillingProps> = ({ billingPeriod, isLoading }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return <Skeleton className="h-4 w-full" />;
  }

  if (!billingPeriod) {
    return null;
  }

  return (
    <div className="flex items-center justify-between">
      <Typography variant="labelSmallBook">
        {t('SUBSCRIPTIONS.BILLING_PERIOD.TITLE').toUpperCase()}
      </Typography>
      <Typography variant="h300">{t(`SUBSCRIPTIONS.BILLING_PERIOD.${billingPeriod}`)}</Typography>
    </div>
  );
};
